<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="用户编号"
                      v-model="listQuery.entity.user.code">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="申请编号"
                      v-model="listQuery.entity.cashApply.appNo">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="开户人"
                      v-model="listQuery.entity.cashApply.accName">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="开户银行"
                      v-model="listQuery.entity.cashApply.bank">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="银行分行"
                      v-model="listQuery.entity.cashApply.accBranch">
            </el-input>
            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"
                      placeholder="银行卡号"
                      v-model="listQuery.entity.cashApply.number">
            </el-input>
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.cashApply.identify"
                       placeholder="状态">
                <el-option v-for="(item,index) in  identifyOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>
            <el-select @change='handleFilter' clearable class="filter-item input" style="width: 130px"
                       v-model="listQuery.entity.cashApply.status"
                       placeholder="状态">
                <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item" :value="index">
                </el-option>
            </el-select>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.cashApply.crateTimes"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="申请时间开始日期"
                    end-placeholder="申请时间结束日期">
            </el-date-picker>
            <el-date-picker
                    @change='handleFilter'
                    value-format="yyyy-MM-dd HH:mm:ss"
                    class="filter-item input"
                    v-model="listQuery.entity.cashApply.passTimes"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="通过时间开始日期"
                    end-placeholder="通过时间结束日期">
            </el-date-picker>

            <div style="display: inline-block">

                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search"
                           @click="handleFilter">查找
                </el-button>

                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"
                           @click="handleDownload">导出
                </el-button>
            </div>
        </div>

        <el-table :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;">
            <yf-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.cashApply.id}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="用户">
                <template slot-scope="scope">
                    <span v-if="scope.row.user">{{scope.row.user.code}}-{{scope.row.user.name}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="申请金额">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{scope.row.cashApply.amount}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="申请编号">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{scope.row.cashApply.appNo}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="开户人">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{scope.row.cashApply.accName}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="开户银行">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{scope.row.cashApply.bank}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="银行分行">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{scope.row.cashApply.accBranch}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="银行卡号">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{scope.row.cashApply.number}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="提现方">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">

                         <el-tag :type="tagTypes[scope.row.cashApply.identify]" v-if="scope.row.cashApply.identify!=null">     {{identifyOptions[scope.row.cashApply.identify]}}</el-tag>

                        </span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="状态">
                <template slot-scope="scope">
                                                <span v-if="scope.row.cashApply">

                         <el-tag :type="tagTypes[scope.row.cashApply.status]" v-if="scope.row.cashApply.status!=null">     {{statusOptions[scope.row.cashApply.status]}}</el-tag>

                        </span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="申请时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{parseTime(scope.row.cashApply.crateTime)}}</span>
                </template>
            </yf-table-column>
            <yf-table-column align="center" label="通过时间" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.cashApply">{{parseTime(scope.row.cashApply.passTime)}}</span>
                </template>
            </yf-table-column>

            <yf-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="canUpdate" size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button v-if="canSave" size="mini" type="danger"
                               @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </yf-table-column>

        </el-table>

        <div class="pagination-container" style="margin-top: 20px">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
<!--                <el-form-item label="用户信息" prop="cashApply.userId">
                    <el-input v-model="temp.user.code" :disabled="true"></el-input>
                </el-form-item>-->
                <el-form-item label="申请金额" prop="cashApply.amount">
                    <el-input v-model="temp.cashApply.amount"></el-input>
                </el-form-item>
                <el-form-item label="申请编号" prop="cashApply.appNo">
                    <el-input v-model="temp.cashApply.appNo"></el-input>
                </el-form-item>
                <el-form-item label="开户人" prop="cashApply.accName">
                    <el-input v-model="temp.cashApply.accName"></el-input>
                </el-form-item>
                <el-form-item label="开户银行" prop="cashApply.bank">
                    <el-input v-model="temp.cashApply.bank"></el-input>
                </el-form-item>
                <el-form-item label="银行分行" prop="cashApply.accBranch">
                    <el-input v-model="temp.cashApply.accBranch"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号" prop="cashApply.number">
                    <el-input v-model="temp.cashApply.number"></el-input>
                </el-form-item>
                <el-form-item label="提现方" prop="cashApply.status">
                    <el-select class="filter-item" v-model="temp.cashApply.identify" placeholder="状态">
                        <el-option v-for="(item,index) in  identifyOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="cashApply.status">
                    <el-select class="filter-item" v-model="temp.cashApply.status" placeholder="状态">
                        <el-option v-for="(item,index) in  statusOptions" :key="item" :label="item"
                                   :value="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申请时间" prop="cashApply.crateTime">
                    <el-date-picker v-model="temp.cashApply.crateTime" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="申请时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="通过时间" prop="cashApply.passTime">
                    <el-date-picker v-model="temp.cashApply.passTime" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="通过时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="汇款凭证" prop="cashApply.img">
                    <el-upload
                            ref="imgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :file-list="imgList"
                            :on-success="(response, file, fileList)=>handleImgUploadSuccess(imgList,file)"
                            :data="qData"
                            :on-remove="(file, fileList)=>handleImgRemove(imgList,file)">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }

    .filter-item {
        margin-bottom: 10px;
    }

    .filter-item.input {
        /*line-height: 60px*/
        margin-right: 10px;
    }
</style>

<script>
    import {list, options, info, save, update, remove,down} from '@/api/cash_apply'
    import waves from '@/directive/waves' // 水波纹指令
    import {downExcel} from '@/utils/down.js'
    import {parseTime} from '@/utils'

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import {mapGetters} from 'vuex'
    import {hasAuth} from '@/utils/auth'

    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                crateTime: null
                ,
                passTime: null
                ,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'cashApply.id desc',
                    entity: {
                        cashApply:
                            {
                                id: null,
                                userId: null,
                                amount: null,
                                appNo: null,
                                accName: null,
                                bank: null,
                                accBranch: null,
                                number: null,
                                img: null,
                                crateTime: null,
                                passTime: null,
                                identify: null,
                                status: null
                            }
                        , user:
                            {
                                code: null,
                                name: null,
                            }
                    }
                },
                statusOptions: ["待审核", "通过", "拒绝"],
                identifyOptions: ["个人", "店铺"],
                tagTypes: ['info', '', 'warning', 'danger', 'warning'],
                temp: {

                    cashApply:
                        {
                            id: null,
                            userId: null,
                            amount: null,
                            appNo: null,
                            accName: null,
                            bank: null,
                            accBranch: null,
                            number: null,
                            img: null,
                            crateTime: null,
                            passTime: null,
                            identify: null,
                            status: null
                        }

                    , user:
                        {
                            code: null,
                            name: null,
                        }
                }
                ,
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    update: '修改',
                    create: '新增'
                }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible: false,
                imgList: [],
                rules:
                    {
                        'cashApply.userId': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.amount': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.appNo': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.accName': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.bank': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.accBranch': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.number': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.img': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.crateTime': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.passTime': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'change'
                            }
                        ]
                        ,
                        'cashApply.status': [
                            {
                                required: false,
                                message: '必填字段',
                                trigger: 'blur'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData:
                    {
                        token: '',
                        key: ''
                    }
            }
        },
        created() {
            this.getList()
            this.getOptions()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'cash:apply:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'cash:apply:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'cash:apply:update')
            },
            canList() {
                return hasAuth(this.perms, 'cash:apply:list')
            }
        },
        methods: {
            parseTime(time) {
                if (!time) return ''
                return parseTime(time, '{y}-{m}-{d} {h}:{i}:{s}')
            },
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })
            },
            getOptions() {
                options().then(res => {
                    this.statusOptions = res.data.statusOptions
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row) {
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row) {

            },
            beforeFormCommit() {
                this.initImgName()// 图片转换
            },
            resetTemp(row) {

                this.temp = {
                    cashApply: {}
                }
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData()
                }).catch(() => {
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.imgList = strsToList(this.temp.cashApply.img, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.imgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.cashApply.img = listToStrs(this.imgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()

                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData() {
                // const ids = [this.temp.cashApply.id]
                const ids = [this.list[this.index].cashApply.id]
                remove({ids: ids}).then(res => {
                    // 从当前队列中移除
                    this.list.splice(this.index, 1)
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleUpdate(scope) {
                this.beforeFormShow(scope.row)
                info(scope.row.cashApply.id).then(res => {
                    this.temp = res.data
                    this.dialogStatus = 'update'
                    this.dialogFormVisible = true
                    this.$nextTick(() => {
                        this.$refs['dataForm'].clearValidate()
                    })
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if (valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                // this.list.splice(this.index, 1, this.temp)
                                this.getList()
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                down(this.listQuery).then(res => {
                    downExcel(res)
                    this.downloadLoading = false
                    this.$notify({
                        title: '成功',
                        message: '下载成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            // formatJson(filterVal, jsonData) {
            //     return jsonData.map(v => filterVal.map(j => {
            //         return v[j]
            //     }
            // ))
            // },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).catch(error => {
                    console.log(error)
                })
            },
            handleImgUploadSuccess(imgList, file) {
                imgList.push({name: file.response.key, url: domain + file.response.key})
            },
            handleImgRemove(imgList, file) {
                for (var fn of imgList) {
                    if (fn.name === file.name) {
                        imgList.splice(imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
